<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <SvgButtons @openModal="modal=true, text=$event, $set(vistos,$event,true)" @finished="$store.commit('nextShow', true)"/>
    </div>
    <modal-app v-model="modal" :fullscreen="false" width="700px">
      <h1 class="modal-title">{{modalTitle}}</h1>
      <p>{{modalText}}</p>
      <div v-if="text == 1" class="text-xs-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 347 103" width="26em">
          <g id="diapositiva_6" data-name="diapositiva 6">
            <path stroke="#fff" stroke-miterlimit="10" stroke-width="2" fill="#00dbd7" class="fix-svg-origin animated bounceIn dura-1" d="M5.35 6.08H173.6v46H5.35z"/>
            <path fill="#ffe300" stroke="#fff" stroke-miterlimit="10" stroke-width="2" class="fix-svg-origin animated bounceIn dura-2" d="M5.35 52.33H173.6v46H5.35z"/>
            <path fill="#beeb7b" stroke="#fff" stroke-miterlimit="10" stroke-width="2" class="fix-svg-origin animated bounceIn dura-3" d="M173.48 6.08h168.25v46H173.48z"/>
            <path fill="#ff801c" stroke="#fff" stroke-miterlimit="10" stroke-width="2" class="fix-svg-origin animated bounceIn dura-4" d="M173.48 52.33h168.25v46H173.48z"/>
            <text class="cls-5 fix-svg-origin animated fadeIn dura-1" transform="translate(22.34 38.01)">
              Descubiertas
            </text>
            <text class="cls-5 fix-svg-origin animated fadeIn dura-2" transform="translate(23.92 84.26)">
              Recuperables
            </text>
            <text class="cls-5 fix-svg-origin animated fadeIn dura-3" transform="translate(187.6 38.01)">
              Remanentes
            </text>
            <text class="cls-5 fix-svg-origin animated fadeIn dura-4" transform="translate(195.41 84.26)">
              Comerciales
            </text>
          </g>
        </svg>
      </div>
    </modal-app>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 04'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 2/diapositiva-5'

export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Continuemos descubriendo la clasificación ahora desde el proceso de producción. <span class='instruccion'>Haz clic en los iconos para conocer más.</span>" 
      ],
      text: 0,
      modal: false
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  computed: {
    modalTitle: function(){
      switch(this.text){
        case 0: return 'Producción'
        case 1: return 'Reservas '
        case 2: return 'Reservas  probadas'
        case 3: return 'Reservas  probables'
        case 4: return 'Reservas  posibles'
        case 5: return 'Recursos contingentes'
        case 6: return 'Recursos no recuperables'
        case 7: return 'Recursos prospectivos'
      }
    },
    modalText: function(){
      switch(this.text){
        case 0: return 'Es la cantidad de petróleo recuperada en cierta fecha; son, por tanto, las reservas producidas.'
        case 1: return 'Son aquellas cantidades de petróleo comercialmente recuperables de acumulaciones conocidas a una fecha determinada bajo condiciones definidas. Deben satisfacer los siguientes criterios:'
        case 2: return 'Son los volúmenes estimados de petróleo, gas natural, condensado, líquido del gas natural y sustancias asociadas recuperables, con razonable certeza de yacimientos conocidos, de acuerdo a la información geológica y de ingeniería disponible bajo condiciones económicas definidas, métodos de operación y regulaciones gubernamentales vigentes.'
        case 3: return 'Son los volúmenes estimados de petróleo, gas natural, condensado, líquido del gas natural y sustancias asociadas en las cuales la información geológica y de ingeniería, indica desde el punto de vista de su recuperación, un mayor grado de incertidumbre comparado con las reservas probadas, pero con mayor certeza de recuperación con respecto a las reservas posibles.'
        case 4: return 'Son los volúmenes estimados de petróleo, gas natural, condensado, líquido del gas natural y sustancias asociadas recuperables en las cuales la información geológica y de ingeniería, indica desde el punto de vista de su recuperación un mayor grado de incertidumbre comparado con las reservas probables.'
        case 5: return 'Son aquellas cantidades de petróleo recuperables estimadas a una fecha determinada de acumulaciones conocidas, pero que el desarrollo comercial no está suficientemente maduro debido a una o más contingencias.'
        case 6: return 'Es aquella porción descubierta o no del petróleo original en un sitio estimado a una fecha determinada que no será recuperado por proyectos de desarrollo futuros. Parte de esta porción, podría recuperarse en el futuro si las condiciones de mercado cambian u ocurren cambios tecnológicos. La porción remanente nunca será recuperada debido a las restricciones físicas y químicas representadas por la interacción de los fluidos y la roca.'
        case 7: return 'Son aquellas cantidades de petróleo recuperables estimadas a una fecha determinada de acumulaciones conocidas, potencialmente recuperables de acumulaciones no descubiertas por la aplicación de futuros proyectos de desarrollo. Estos recursos tienen la oportunidad de ser descubiertos.'
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .cls-5{font-size:25px;fill:#1e1e1e;font-family:MyriadPro-BoldCond,Myriad Pro;font-weight:700}.cls-6{letter-spacing:.01em}.cls-9{letter-spacing:0}
</style>
